import { SvgIcon, SvgIconProps } from "@mui/material";

export const PlusDualIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle
        cx="12"
        cy="12"
        r="9"
        fill="#B7BDFB"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M12.003 9.342v5M9.504 11.84h5"
      />
    </svg>
  </SvgIcon>
);
